module.exports = __webpack_public_path__ + "img/Tom-Doerr.bac60821.jpg";